angular.module('businessThread')
    .component('businessThreadList', {
        bindings: {
            page: '<',
            filters: '<'
        },
        templateUrl: 'app/business-thread/list.html',
        controller: function ($scope, $state, BusinessThreadService, BusinessThreadConst) {
            this.BusinessThreadService = BusinessThreadService
            this.reset = () => this.filters = {}

            $scope.$on(BusinessThreadConst.eventUpdate, () => $state.reload())
        }
    })
